import React from "react";

const Search = props => {
  return (
    <svg width="18" height="18" {...props}>
      <path
        fill="#9B9B9B"
        fillRule="nonzero"
        d="M12.5 11h-.79l-.28-.27a6.5 6.5 0 1 0-.7.7l.27.28v.79l5 4.99L17.49 16l-4.99-5zm-6 0a4.5 4.5 0 1 1-.01-8.99A4.5 4.5 0 0 1 6.5 11z"
      />
    </svg>
  );
};

export default Search;
